import { render, staticRenderFns } from "./EstadisticasForm.vue?vue&type=template&id=d3d35f70&scoped=true&lang=pug&"
import script from "./EstadisticasForm.vue?vue&type=script&lang=js&"
export * from "./EstadisticasForm.vue?vue&type=script&lang=js&"
import style0 from "./EstadisticasForm.vue?vue&type=style&index=0&id=d3d35f70&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d35f70",
  null
  
)

export default component.exports